import { render, staticRenderFns } from "./Irrigation.vue?vue&type=template&id=0c242e96&scoped=true&"
import script from "./Irrigation.vue?vue&type=script&lang=js&"
export * from "./Irrigation.vue?vue&type=script&lang=js&"
import style0 from "./Irrigation.vue?vue&type=style&index=0&id=0c242e96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c242e96",
  null
  
)

export default component.exports